/** Thème visuel unique (fond + couleurs d’accent). Les anciens « thèmes » admin n’agissaient que sur des classes CSS identiques. */
const appTheme = {
  bg: 'theme-default',
  text: 'text-white',
  accent: 'text-cyan-400',
  button: 'bg-cyan-500 hover:bg-cyan-400',
  buttonText: 'text-slate-900',
  glow: 'shadow-cyan-500/30'
};

const ThemeWrapper = ({ children, className = '' }) => {
  return (
    <div
      data-testid="theme-wrapper"
      className={`min-h-screen ${appTheme.bg} ${appTheme.text} ${className} relative overflow-x-hidden`}
    >
      {/* Aurore : rose, violet, fuchsia, magenta — variation animée via index.css (hue-rotate) */}
      <div className="absolute inset-0 pointer-events-none">
        <div
          className="aurora-layer-a absolute inset-0 bg-[radial-gradient(92%_68%_at_6%_12%,rgba(244,114,182,0.55),transparent_58%),radial-gradient(88%_72%_at_94%_8%,rgba(167,139,250,0.52),transparent_56%),radial-gradient(95%_78%_at_48%_0%,rgba(217,70,239,0.48),transparent_54%),radial-gradient(72%_58%_at_78%_32%,rgba(192,38,211,0.42),transparent_60%),radial-gradient(68%_52%_at_18%_38%,rgba(139,92,246,0.44),transparent_58%),radial-gradient(55%_48%_at_52%_45%,rgba(236,72,153,0.32),transparent_65%)]"
        />
        <div className="aurora-layer-b absolute inset-0 bg-[linear-gradient(155deg,rgba(139,92,246,0.35)_0%,rgba(219,39,119,0.28)_22%,rgba(244,114,182,0.22)_40%,rgba(99,102,241,0.18)_58%,rgba(2,6,23,0)_82%)] blur-2xl" />
        <div className="aurora-layer-c absolute inset-0 bg-[radial-gradient(55%_42%_at_22%_18%,rgba(250,232,255,0.35),transparent_68%),radial-gradient(48%_40%_at_82%_22%,rgba(251,207,232,0.4),transparent_70%),radial-gradient(45%_38%_at_50%_28%,rgba(196,181,253,0.28),transparent_72%)] blur-xl" />
        <div className="aurora-layer-d absolute inset-0 bg-[radial-gradient(120%_90%_at_50%_100%,rgba(88,28,135,0.25),transparent_55%),radial-gradient(80%_60%_at_0%_50%,rgba(157,23,77,0.15),transparent_50%)] opacity-90" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_115%,rgba(2,6,23,0),rgba(2,6,23,0.35)_68%,rgba(2,6,23,0.82)_100%)]" />
        <div className="absolute inset-0 bg-[linear-gradient(180deg,rgba(2,6,23,0.12)_0%,rgba(2,6,23,0.02)_38%,rgba(2,6,23,0.38)_100%)]" />
      </div>
      {children}
    </div>
  );
};

export const useTheme = () => appTheme;

export default ThemeWrapper;
